export class ListCustomerPaymentViewModel {
    id: number;
    hubCreatedId: number;
    customerId: number;
    totalShipment: number;
    grandTotal: number;
    adjustPrice: number;
    attachmentId: number;
    shipmentIds: number[] = [];
    dateFrom: Date;
    dateTo: Date;
    listCustomerPaymentTypeId: number = 1;
    note: string;
    locked: boolean;
    beforeGrandTotal: number = 0;
    discountPercent: number = 0;
    grandTotalPrice: number = 0;
    grandTotalCOD: number = 0;
    acceptDateFrom: any;
    acceptDateTo: any;
    currentAcceptDate: any;
    paymentDate?: any;
    paymentAccount: string;
    paymentTotal: number = 0;
}